import React, { useEffect, useState } from 'react';
import { getPlanPlaceDates } from '../services/api';
import ProgressBar from './common/ProgressBar';
import PlanTimeInfo from './common/PlanTimeInfo';
import './PlanGroupSchedule.css';

/**
 * PlanGroupSchedule Component
 * Toont alle planplaatsen voor een geselecteerde plangroep
 */
const PlanGroupSchedule = ({ conneoId, group, onBack, onSelectPlace }) => {
  const [planPlaces, setPlanPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlanPlaces = async () => {
      try {
        setLoading(true);
        const response = await getPlanPlaceDates(group.objectid);
        
        if (response.meta.status === 'success') {
          setPlanPlaces(response.data);
        } else {
          setError('Er is een fout opgetreden bij het ophalen van de planning.');
        }
      } catch (err) {
        console.error('Error fetching plan places:', err);
        setError('Er is een fout opgetreden bij het ophalen van de planning.');
      } finally {
        setLoading(false);
      }
    };

    // Stel paginatitel in
    document.title = `Conneo Planning - ${group.name}`;
    
    fetchPlanPlaces();
  }, [group]);

  if (loading) {
    return <div className="loading">Laden...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error">{error}</div>
        <button onClick={onBack} className="btn-back">← Terug</button>
      </div>
    );
  }

  return (
    <div className="plan-group-schedule">
      <h2 className="group-header">Plangroep: {group.name}</h2>
      
      <div className="plan-places-list">
        {planPlaces.map((place) => {
          // Parse numerieke waarden
          // const plannedTime = parseFloat(place.totalDone || 0); //plannedTime
          // const plannableTime = parseFloat(place.plannedTime || place.plannableTime || 8); //plannableTime
          let availableTime = parseFloat(place.plannableTime || 0.1); //availableTime
          let plannedTime = parseFloat(place.totalDone || 0);  //plannedTime
          let plannableTime = parseFloat(place.plannedTime || place.plannableTime || 8); //plannableTime
          console.log('plannedTime:', plannedTime);
          console.log('plannableTime:', plannableTime);
          if (isNaN(plannedTime) || plannedTime <=0) {
            if (place.planItems && place.planItems.length > 0) 
              plannedTime = place.planItems.length * 0.01;
            else
              plannedTime = 0;
          }
          if (isNaN(plannableTime) || plannableTime <= 0) {
            if (place.planItems && place.planItems.length > 0) 
              plannableTime = place.planItems.length * 0.01 // 30 minuten per taak
            else
              plannableTime = 0;
          }
        
                  
          return (
            <div 
              key={place.objectid} 
              className="plan-place-item"
              onClick={() => onSelectPlace(place)}
            >
              <h3 className="place-name">{place.planPlaceId_S}</h3>
              
              <ProgressBar 
                plannedTime={plannedTime} 
                plannableTime={plannableTime} 
              />
              
              <PlanTimeInfo 
                plannedTime={plannedTime}
                plannableTime={plannableTime}
                planItems={place.planItems}
                availableTime={availableTime}
              />
            </div>
          );
        })}
      </div>
      
      <button onClick={onBack} className="btn-back">← Terug</button>
    </div>
  );
};

export default PlanGroupSchedule;